import axios from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';
import { getIsDemoExperience } from 'services/globalConfig.services';
import APIError from '../exceptions/APIError';

export const resubscribe = async (
  shipmentPk: number,
  orgId: number,
  channel: string,
  email: string,
): Promise<void> => {
  // Unreachable once unsubscribe is blocked — the modal that holds this button
  // never opens. Branched anyway so no path can leak a live write.
  if (getIsDemoExperience()) return;

  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/subscription/resubscribe-email-sms/`;
    await axios.post(url, {
      organization_id: orgId,
      shipment_pk: shipmentPk,
      medium_type: channel,
      handler: email?.replace(/\s/g, '+'),
    });
  } catch (error) {
    throw new APIError(error.message);
  }
};

export const unsubscribe = async (
  shipmentPk: number,
  channel: string,
  email: string,
): Promise<void> => {
  // Fires automatically on `pp_unsubscribe=true` in the URL, with no click.
  // Nothing reads a response: the subscription modal simply never opens.
  if (getIsDemoExperience()) return;

  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/subscription/unsubscribe-email/`;
    await axios.post(url, {
      shipment_pk: shipmentPk,
      medium_type: channel,
      handler: email?.replace(/\s/g, '+'),
    });
  } catch (error) {
    throw new APIError(error.message);
  }
};
